import React from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import { useTranslation } from "react-i18next";

const InvestHistoryPage = () => {
	const { t } = useTranslation();
	return (
		<NavbarAndSidebarLayout menu={["invest", "history"]} type={"main"}>
			<PageHeader />
			<h1>"{t("pages.investment.InvestHistoryPage.title")}"</h1>
		</NavbarAndSidebarLayout>
	);
};

export default InvestHistoryPage;
